import { render, staticRenderFns } from "./driverAnnualReview.vue?vue&type=template&id=0523b7c5&scoped=true&"
import script from "./driverAnnualReview.vue?vue&type=script&lang=js&"
export * from "./driverAnnualReview.vue?vue&type=script&lang=js&"
import style0 from "./driverAnnualReview.vue?vue&type=style&index=0&id=0523b7c5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523b7c5",
  null
  
)

export default component.exports